export const getBadgeText = ({ type, formatTranslation }) => {
  const label =
    type === "MoreColors"
      ? formatTranslation("plp_web_product_tile_badge_more_colors")
      : formatTranslation("plp_web_product_tile_badge_mix_match");

  return label;
};
